export const mapProfileSizetoBadgeSize = (size) => {
    switch (size) {
        case 'xxsmall':
        case 'xsmall':
        case 'small':
            return 'small';
            break;
        case 'medium':
        case 'large':
            return 'medium';
            break;
        case 'xlarge':
        case 'xxlarge':
        case 'xxxlarge':
        case 'xxxxlarge':
            return 'large';
            break;
        default:
            return undefined;
    }
};
//# sourceMappingURL=map-profile-size-to-badge-size.js.map